import { type FC } from "react";

import { StepperItem, getStepStatus } from "./ModalStepper";

type LegalAuthorityStep = 1 | 2 | 3;

const STEPS: { stepNumber: number; label: string; status: LegalAuthorityStep }[] = [
  { stepNumber: 1, label: "Introduction", status: 1 },
  { stepNumber: 2, label: "Will", status: 2 },
  { stepNumber: 3, label: "Estate size", status: 3 },
];

interface LegalAuthoritySidebarProps {
  activeStep: LegalAuthorityStep;
}

export const LegalAuthoritySidebar: FC<LegalAuthoritySidebarProps> = ({ activeStep }) => (
  <div className="hidden sm:flex h-full w-[250px] shrink-0 flex-col gap-4 border-r border-primary bg-white p-6">
    <p className="text-base font-semibold leading-[1.55] tracking-[-0.32px] text-primary">
      Path to legal authority
    </p>
    <div className="flex flex-col gap-2">
      {STEPS.map(({ stepNumber, label, status }) => (
        <StepperItem
          key={stepNumber}
          stepNumber={stepNumber}
          label={label}
          status={getStepStatus(status, activeStep)}
        />
      ))}
    </div>
  </div>
);
